/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ICreateShareFileIntegrationMutationVariables = Types.Exact<{
  shareFileIntegrationInput: Types.IShareFileIntegrationInputAttributes;
}>;

export type ICreateShareFileIntegrationMutation = {
  __typename?: 'Mutation';
  createShareFileIntegration?: {
    __typename?: 'CreateShareFileIntegrationPayload';
    success: boolean;
    errors?: Array<string> | null;
    shareFileIntegration?: { __typename?: 'ShareFileIntegration'; provider: string; id: string } | null;
  } | null;
};

export const CreateShareFileIntegrationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createShareFileIntegration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shareFileIntegrationInput' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShareFileIntegrationInputAttributes' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createShareFileIntegration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shareFileIntegrationInput' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shareFileIntegrationInput' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shareFileIntegration' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ICreateShareFileIntegrationMutation, ICreateShareFileIntegrationMutationVariables>;
